var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 24,
    rx: 4,
    fill: "#E9E9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_19335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19C18.366 19 21.5 15.866 21.5 12C21.5 8.13401 18.366 5 14.5 5C10.634 5 7.5 8.13401 7.5 12C7.5 15.866 10.634 19 14.5 19Z",
    fill: "#EA001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19C28.366 19 31.5 15.866 31.5 12C31.5 8.13401 28.366 5 24.5 5C20.634 5 17.5 8.13401 17.5 12C17.5 15.866 20.634 19 24.5 19Z",
    fill: "#FFA200",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_19335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.11e2c1188be7894b66d0930365790b06.svg";
export { ForwardRef as ReactComponent };